<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content ? content : `Eco-boss` }}</template>
  </metainfo>

  <RouterView/>

  <div class="cookie-message" v-if="!isCookie">
    <div class="text">
      Мы используем файлы cookie только для персонализации контента и анализа нашего трафика. Нажимая кнопку
      "Разрешить", вы подтверждаете свое согласие на использование всех файлов cookie на этом веб-сайте и соглашаетесь
      с нашей <a href="/privacy-policy" style="color: #487757" target="_blank">Политикой конфиденциальности</a>. Согласие может быть отозвано в любое время.
    </div>

    <a-button type="primary" @click="handleAllowCookie">Разрешить</a-button>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta'

const getTitle = () => {
  return window.location.hostname === "xn----htbmfuthi8f2a.xn--p1ai"
  //|| window.location.hostname === "localhost"
      ? "Эко студия маникюра|Челябинск"
      : "Eco-boss"
}

export default {
  setup() {
    useMeta({
      title: getTitle(),
      htmlAttrs: { lang: 'ru', amp: true }
    })
  },
  data: function () {
    return {
      isCookie: localStorage.getItem("cookie-show-key") || 0,
    }
  },
  name: 'App',
  methods: {
    handleAllowCookie() {
      localStorage.setItem("cookie-show-key", 1);
      this.isCookie = 1;
    },
  }
};
</script>

<style lang="less">
.cookie-message {
  position: fixed;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  column-gap: 40px;
  font-size: 14px;
  line-height: 1.5;
}
</style>